export const getDataSource = (origin) => {
  const dataSource = [];
  for (const key in origin) {
    dataSource.push({
      label: origin[key],
      value: key,
    });
  }
  return dataSource;
};

/**
 * 时间频率枚举
 */
export const TIME_FREQUENCY = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
};

/**
 * 时间频率枚举label
 */
export const TIME_FREQUENCY_LABEL = {
  [TIME_FREQUENCY.DAILY]: '每日',
  [TIME_FREQUENCY.WEEKLY]: '每周',
  [TIME_FREQUENCY.MONTHLY]: '每月',
};

/**
 * 时间频率枚举数据源
 */
export const getTimeFrequency = getDataSource(TIME_FREQUENCY_LABEL);
